<template>
  <div>
    <topPage :title="title" :bgImg="bgImg" />
    <doubleImageAndText
      id="next"
      img="computerShadow.png"
      img2="computer.png"
      title="Notre constat"
      text="Ces dernières années, dans le but d'améliorer nos services, nous avons testé plusieurs solution pour entamer notre transition digital. La problématique d’avoir un vrai logiciel cross plateforme regroupant tout les outils nécessaires à Pagesti nous est apparu insoluble dans les offres proposer. nous avons donc décider de ne plus être dépendant des fournisseur de plateforme mais de crée la notre faite par et pour Pagesti."
    ></doubleImageAndText>
    <itemList
      color="#D4EBFF"
      title="spher: solution immobilère 360°"
      text="Spher est une plateforme crée par et pour Pagesti dédié à l’administration de bien. Elle prend en compte les aspects du métier permettant ainsi à tous les acteurs de ce secteurs de mieux communiquer et gérer leurs activité."
      :list="list"
    ></itemList>
    <ImgAndTextLeft
      bgcolor="#D4EBFF"
      img="computer2.png"
      title="les gains d’un tel <br>dispositif"
      text="Spher nous rend la vie plus simple en nous faisant économisé du temps sur nos process de travail. Le faite que les taches simple soit réalisé par la plateforme directement nous laisse plus de temps pour réalisé des taches plus complexe nécessitant toute l’attention de nos gestionnaire. Le point crucial par ailleurs est de consacrer plus de temps a nos copropriétaire en leur fournissant un contact humain à chaque instant en répondant a leur interrogation. Une vrai visibilité sur les projets & incidents pour les gestionnaire et les copropriétaires rendent totalement transparent nos méthodes de travail en vous tenant informer a tout moment."
    ></ImgAndTextLeft>
    <FullSizeImg
      img="parc2.png"
      title="POUR QUE LES COPROS & gestionnaire s’entendent"
      text="Spher à pour but d’etre un vrai outil de communication entre Pagesti et nos copropriétaire. c’est pour cela que nous proposons pour chaque projet & incident une vrai timeline interactive ou les nouvelles informations seront postées et ou vous pourrez interagir ou déclarer un incident. Cette fonctionnalité réduit les suite de mail en vous proposant une interface claire et facile a suivre du début a la fin."
    ></FullSizeImg>
  </div>
</template>

<script>
import topPage from "../components/topPage";
import doubleImageAndText from "../components/doubleImageAndText";
import itemList from "../components/itemList";
import ImgAndTextLeft from "../components/imageAndTextLeft";
import FullSizeImg from "../components/fullSizeImg";
export default {
  name: "Digital",
  components: {
    topPage,
    doubleImageAndText,
    itemList,
    ImgAndTextLeft,
    FullSizeImg
  },
  data: () => ({
    title: "PAGESTI <br>& LA DIGITILISATION",
    bgImg: "paris_illu.png",
    list: [
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      { img: "test.png", title: "test", text: "balbalba balba blab lbalba bal" }
    ]
  })
};
</script>
